class LocalizedStrings {
  lang = new Map();
  userLang = "en";

  setLocale = (locale) => {
    this.userLang = locale;
    localStorage.setItem("app_locale", locale);
    document.location.reload();
  };

  getLocale = () => this.userLang;

  constructor() {
    // const locale = localStorage.getItem("app_locale")
    // if (locale) {
    //     this.userLang = locale
    // } else {
    //     if (navigator.languages != undefined) {
    //         this.userLang = navigator.languages[0];
    //     }
    //     this.userLang = this.userLang.split("-")[0]
    // }

    if (navigator.languages != undefined) {
      this.userLang = navigator.languages[0];
    }
    this.userLang = this.userLang.split("-")[0];
    this.lang.set("en", {
      "---": "---",
      art: "art",
      mirror: "mirror",
      replace_background: "Replace background",
      portrait: "portrait",
      none: "none",
      landscape: "landscape",
      graysepia: "other",
      brightness: "brightness",
      color: "color",
      posterize: "posterize",
      both: "both",
      saturation: "saturation",
      green: "green",
      red: "red",
      blue: "blue",
      background: "background",
      people: "people",
      close: "close",
      add_style: "add style",
      oil: "oil",
      nocolor: "nocolor",
      art_style: "style",
      save_preset: "Save Preset",
      apply_preset: "Apply Preset",
      save_as_zip: "Save as an archive (zip) and keep the original image name.",
      new: "new",
      copy: "copy",
      layer: "layer",
      saturated: "saturated",
      blue: "blue",
      silver: "silver",
      neon: "neon",
      emboss: "emboss",
      cartoon: "cartoon",
      blured: "blured",
      black: "black",
      ripple: "ripple",
      sepia: "sepia",
      noise: "noise",
      vignette: "vignette",
      gray: "gray",
      rate_app: "Rate the app",
      rate_app_body: "Please rate this application",
      rate_btn: "Ok",
      unckeck_all: "unckeck all",
      visibility: "visibility",
      download: "download",
      Download: "Download",
      left: "left",
      center: "center",
      right: "right",
      justify: "justify",
      bold: "bold",
      italic: "italic",
      underline: "underline",
      linethrough: "linethrough",
      overline: "overline",
      remove_all_objects: "Remove All Objects?",
      remove_all_objects_message: "Nothing was selected. Remove all objects?",
      size: "size",
      dotted: "dotted",
      rounded: "rounded",
      align: "align",
      style: "style",
      family: "family",
      random_color: "random color",
      w: "width",
      blur: "blur",
      font: "font",
      stroke: "outline",
      fill: "filling",
      fills: "fill",
      shadow: "shadow",
      forward_selected_object: "forward selected object",
      backward_selected_object: "backward selected object",
      make_screenshot: "make screenshot",
      add_image: "add image",
      add: "add",
      undo: "undo",
      eraser: "erase",
      select: "select object",
      line: "line",
      circle: "circle",
      triangle: "triangle",
      brush: "brush",
      custom_shape: "custom shape",
      square: "square",
      text: "text",
      remove_selected_object: "remove selected object",
      save: "save",
      save_drawing: "save drawing",
      apply_drawing: "apply drawing",
      filter: "Filters",
      resize: "Resize",
      no_files_select: "Select images to process",
      no_files_select_message: "First you need to select images for processing",
      cancel: "cancel",
      ok: "ok",
      images: "images",
      remove: "remove",
      add_more_images: "add more images",
      add: "add",
      add_gradient: "add gradient",
      add_pattern: "add pattern",
      clear_all: "clear all",
      clear: "clear",
      autocrop: "auto crop",
      files: "Files",
      draw: "Draw",
      find: "Find",
      settings: "Settings",
      person: "person",
      face: "face",
      animal: "animal",
      vehicle: "vehicle",
      food: "food",
      furniture: "furniture",
      sport: "sport",
      electronics: "electronics",
      clothes: "clothes",
      kitchen: "kitchen",
      any: "any",
      resolution: "Resolution",
      type: "Export as",
      quality: "Quality",
      height: "Height",
      width: "Width",
      download: "Download",
      drop: "Drop images here or click",
      files: "Files",
      ratio: "Preserve ratio",
      apply: "Apply",
      reset: "Reset",
      opacity: "opacity",
      effect: "effect",
      sharpen: "sharpness",
      blur: "blur",
      pixelation: "pixelation",
      oldMovie: "old movie",
      diffusion: "diffusion",
      sketch: "sketch",
      edges: "edges",
      shape: "shape",
      flip: "flip",
      handbag: "handbag",
      tie: "tie",
      suitcase: "suitcase",
      backpack: "backpack",
      umbrella: "umbrella",
      chair: "chair",
      couch: "couch",
      bed: "bed",
      toilet: "toilet",
      frisbee: "frisbee",
      skis: "skis",
      snowboard: "snowboard",
      sports_ball: "sports ball",
      kite: "kite",
      baseball_bat: "baseball bat",
      baseball_glove: "baseball glove",
      skateboard: "skateboard",
      surfboard: "surfboard",
      tennis_racket: "tennis racket",
      bottle: "bottle",
      dining_table: "dining table",
      wine_glass: "wine glass",
      cup: "cup",
      fork: "fork",
      knife: "knife",
      spoon: "spoon",
      bowl: "bowl",
      tv: "tv",
      laptop: "laptop",
      mouse: "mouse",
      remote: "remote",
      keyboard: "keyboard",
      cell_phone: "cell phone",
      microwave: "microwave",
      oven: "oven",
      toaster: "toaster",
      sink: "sink",
      refrigerator: "refrigerator",
      bicycle: "bicycle",
      car: "car",
      motorcycle: "motorcycle",
      airplane: "airplane",
      bus: "bus",
      train: "train",
      truck: "truck",
      boat: "boat",
      banana: "banana",
      apple: "apple",
      sandwich: "sandwich",
      orange: "orange",
      broccoli: "broccoli",
      carrot: "carrot",
      hot_dog: "hot dog",
      pizza: "pizza",
      donut: "donut",
      cake: "cake",
      bird: "bird",
      cat: "cat",
      dog: "dog",
      horse: "horse",
      sheep: "sheep",
      cow: "cow",
      elephant: "elephant",
      bear: "bear",
      zebra: "zebra",
      giraffe: "giraffe",
    });
    this.lang.set("ru", {
      art: "артист",
      mirror: "зеркало",
      replace_background: "Заменить фон",
      portrait: "портрет",
      none: "никакой",
      landscape: "ландшафт",
      graysepia: "остальные",
      brightness: "яркость",
      color: "цвет",
      posterize: "постеризовать",
      saturation: "насыщенность",
      green: "зеленый",
      red: "красный",
      blue: "синий",
      both: "всё",
      background: "фон",
      people: "люди",
      close: "закрыть",
      add_style: "добавить стиль",
      oil: "краска",
      art_style: "стиль",
      nocolor: "безцветный",
      save_preset: "Сохранить Пресет",
      apply_preset: "Применить Пресет",
      "---": "---",
      save_as_zip:
        "Сохранить как архив (zip) и оставить исходное название изображения.",
      new: "новый",
      copy: "копировать",
      layer: "слои",
      rate_app: "Оценить приложение",
      rate_app_body: "Пожалуйста, оцените это приложение",
      rate_btn: "Оценить",
      unckeck_all: "cнять все",
      visibility: "видимость",
      download: "скачать",
      Download: "Скачать",
      left: "влево",
      center: "центр",
      right: "вправо",
      justify: "по ширине",
      bold: "жирный",
      italic: "курсив",
      underline: "подчеркнуть",
      linethrough: "сквозь",
      overline: "зачеркнуть",
      remove_all_objects: "Удалить все объекты?",
      remove_all_objects_message:
        "Ничего не было выбрано. Удалить все объекты?",
      size: "размер",
      dotted: "пунктир",
      rounded: "округлый",
      align: "выровнять",
      style: "стиль",
      family: "семейство",
      random_color: "случайный цвет",
      w: "размер",
      blur: "размытие",
      font: "шрифт",
      stroke: "контур",
      fill: "заливка",
      fills: "заполнить",
      shadow: "тень",
      forward_selected_object: "вперёд выбранный объект",
      backward_selected_object: "назад выбранный объект",
      make_screenshot: "сделать скриншот",
      add_image: "добавить изображение",
      add: "добавить",
      add_gradient: "добавить градиент",
      add_pattern: "добавить паттерн",
      undo: "отменить",
      eraser: "стереть",
      select: "выбрать объект",
      line: "линия",
      circle: "круг",
      triangle: "треугольник",
      brush: "кисть",
      custom_shape: "нестандартная форма",
      square: "квадрат",
      text: "текст",
      remove_selected_object: "удалить выбранный объект",
      save: "сохранить",
      save_drawing: "сохранить рисунок",
      apply_drawing: "применить рисунок",
      resize: "Размер",
      filter: "Фильтры",
      origin: "источник",
      no_files_select: "Выберите изображения для обработки",
      no_files_select_message:
        "Сначала нужно выбрать изображения для обработки",
      cancel: "отмена",
      ok: "хорошо",
      images: "изображения",
      remove: "удалить",
      add_more_images: "добавить ещё изображений",
      add: "добавить",
      clear_all: "очистить всё",
      clear: "очистить",
      autocrop: "авто обрезка",
      files: "Файлы",
      draw: "Рисовать",
      find: "Найти",
      settings: "Настройки",
      person: "человек",
      face: "лицо",
      animal: "животное",
      vehicle: "транспорт",
      food: "еда",
      furniture: "мебель",
      sport: "спорт",
      electronics: "электроника",
      clothes: "одежда",
      kitchen: "кухня",
      any: "любые",
      resolution: "Разрешение",
      type: "Экспортировать как",
      height: "Высота",
      width: "Ширина",
      quality: "Качество",
      download: "Скачать",
      drop: "Перетащите изображения сюда или кликните",
      files: "Файлы",
      ratio: "Сохранить соотношение",
      apply: "Применить",
      reset: "Сбросить",
      opacity: "прозрачность",
      effect: "эффект",
      sharpen: "резкость",
      blur: "размытие",
      pixelation: "пикселизация",
      oldMovie: "старое кино",
      diffusion: "рассеивание",
      sketch: "эскиз",
      edges: "края",
      shape: "форма",
      flip: "перевернуть",
      handbag: "сумочка",
      tie: "галстук",
      suitcase: "чемодан",
      backpack: "рюкзак",
      umbrella: "зонтик",
      chair: "стул",
      couch: "диван",
      bed: "кровать",
      toilet: "туалет",
      frisbee: "фрисби",
      skis: "лыжи",
      snowboard: "сноуборд",
      sports_ball: "спортивный мяч",
      kite: "воздушный змей",
      baseball_bat: "бейсбольная бита",
      baseball_glove: "бейсбольная перчатка",
      skateboard: "скейтборд",
      surfboard: "доска для серфинга",
      tennis_racket: "теннисная ракетка",
      bottle: "бутылка",
      dining_table: "обеденный стол",
      wine_glass: "бокал для вина",
      cup: "чашка",
      fork: "вилка",
      knife: "нож",
      spoon: "ложка",
      bowl: "чаша",
      tv: "телевизор",
      laptop: "ноутбук",
      mouse: "компьютерная мышь",
      remote: "пульт",
      keyboard: "клавиатура",
      cell_phone: "телефон",
      microwave: "микроволновка",
      oven: "печь",
      toaster: "тостер",
      sink: "раковина",
      refrigerator: "холодильник",
      bicycle: "велосипед",
      car: "автомобиль",
      motorcycle: "мотоцикл",
      airplane: "самолет",
      bus: "автобус",
      train: "поезд",
      truck: "грузовик",
      boat: "лодка",
      banana: "банан",
      apple: "яблоко",
      sandwich: "бутерброд",
      orange: "апельсин",
      broccoli: "брокколи",
      carrot: "морковь",
      hot_dog: "хотдог",
      pizza: "пицца",
      donut: "пончик",
      cake: "кекс",
      bird: "птица",
      cat: "кошка",
      dog: "собака",
      horse: "лошадь",
      sheep: "овца",
      cow: "корова",
      elephant: "слон",
      bear: "медведь",
      zebra: "зебра",
      giraffe: "жираф",
    });
  }
  getLocalizedStrings() {
    const result = this.lang.get(this.userLang);
    return result || this.lang.get("en");
  }
}

const localizedStrings = new LocalizedStrings();

export default localizedStrings.getLocalizedStrings();
export const initLocale = () => {};
export const getLocale = () => {
  return localizedStrings.getLocale();
};
export const setLocale = (locale) => {
  return localizedStrings.setLocale(locale);
};
